import { Request } from "../../request";
import { getURL } from "../../utils";

// captcha
export const get_captcha = (
  font_color = "",
  color = "",
  base_color = ""
) => {
  return Request.get(getURL(`/api/v1/accounts/captcha/`), {
    font_color,
    color,
    base_color,
  });
};

// login
export const post_login = ({phone_number, captcha, captcha_uuid, otp_code}) => {
  return Request.post(getURL(`/api/corporation-pa/accounts/login/`), {
    phone_number,
    captcha,
    captcha_uuid,
    otp_code
  });
};
